// import { useSize } from 'ahooks';
import { Space } from 'antd';
import React, { Fragment, useCallback, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import FilePaste from '@/assets/images/header/file-paste.react.svg?react';
import ShoppingCart from '@/assets/images/header/shopping-cart.react.svg?react';
import { MultiApp, useAppConfig } from '@/config/context';
import { LocaleSwitch } from '@/i18n/locale-switch';
import { ENV } from '@/infrastructure/env-config';
import { BASE_NAME, getParamFromUrl } from '@/infrastructure/history';
import { getPid } from '@/infrastructure/product-info';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { isVersion } from '@/infrastructure/utils/version-strategy';
import { OverseasButton } from '@/presentation/components/overseas-button';
import { AvatarMenu } from '@/presentation/layouts-pro/header/avatar';
import { TopMenuButton } from '@/presentation/layouts-pro/header/button';
import { Notice } from '@/presentation/layouts-pro/header/notice';
import { stores, useStores } from '@/presentation/store';
import { getCookie, setCookie } from '@raft/utils';
import HeaderIcon from './copilot/icons/header-icon.react.svg?react';


export const TopMenu = () => {
  const { t } = useTranslation();
  const config = useAppConfig();
  const { isFreeProduct } = useStores().ProductStore;
  const urlProductId = getParamFromUrl('productId');
  const { setCopilotVisible, copilotChatVisible, isInLLMWhitelist } = stores.LayoutStore;
  const isFree = isFreeProduct();
  const location = useLocation();
  const ref = useRef(null);
  const [, setPopVisible] = useState(false);

  // const size = useSize(ref);

  const onBackFreeVersion = () => {
    const pid = getPid();

    // 种cookie标识，不再执行灰度逻辑
    setCookie('bugly-disable-redirect', true, 1, '/', '.qq.com');

    if (urlProductId) {
      window.location.href = `https://bugly.qq.com/v2/crash-reporting/dashboard/${urlProductId}?pid=${pid}`;
    } else {
      window.location.href = 'https://bugly.qq.com/v2/workbench/apps/';
    }
  };

  // 用过免费版
  const usedFreeVersion = getCookie('bugly-free-useage');
  const enableShowBackBtn = !ENV.isEu && ((location.pathname === '/workbench/apps' && usedFreeVersion) || (urlProductId && isFree));

  // 切换 Copilot 显示状态
  const handleToggleCopilot = useCallback(() => {
    setCopilotVisible(!copilotChatVisible);
    setPopVisible(false);
  }, [setCopilotVisible, copilotChatVisible]);

  return (
    <div ref={ref}>
      <Space size={24}>
        <Space style={{ marginTop: '15px', minWidth: 259, justifyContent: 'flex-end' }}>
          {enableShowBackBtn && <TopMenuButton onClick={onBackFreeVersion}>{t('返回Bugly免费版')}</TopMenuButton>}
          {isVersion(MultiApp.WOA, MultiApp.Pro, MultiApp.Dji, MultiApp.Eu, MultiApp.Internal) && isInLLMWhitelist && (
            <Fragment>
              {urlProductId && <TopMenuButton onClick={handleToggleCopilot}>
                <HeaderIcon />
                <span>Bugly Copilot</span>
              </TopMenuButton>}
            </Fragment>
          )}
          {!ENV.isOverseas && <OverseasButton pageId={PAGE_ID.topMenu} />}
          {!ENV.isOverseas && <TopMenuButton onClick={() => {
            const url = new URL(window.location.origin);
            const productId = getParamFromUrl('productId');
            url.pathname = `${BASE_NAME}/resource-pack`;
            if (productId) {
              url.searchParams.set('appId', productId);
            }
            reportClick(PAGE_ID.topMenu, CUSTOM_ACTIONS.commonEnterBuyResourcePackPage, {
              from: !productId ? `${PAGE_ID.topMenu}-no-product-id` : `${PAGE_ID.topMenu}-has-product-id`,
            });
            window.open(url.toString(), '_blank');
          }}>
            <ShoppingCart />
            <span>{t('购买资源包')}</span>
          </TopMenuButton>}
          <TopMenuButton onClick={() => window.open(config.docRoot, '_blank')}>
            <FilePaste />
            <span>{t('文档中心')}</span>
          </TopMenuButton>
          <Notice />
        </Space>
        <LocaleSwitch />
        <AvatarMenu /></Space>
    </div>
  );
};

